import React from "react";

const CustomerDetails = ({ caseDetails, leftPosition, topPosition }) => {
  return (
    <div
      className="details_tooltip_wrapper customer-details-tooltip"
      style={{ left: leftPosition, top: topPosition }}
    >
      <div className="x_panel">
        <div className="x_title">
          <h2>Customer Details</h2>
          <div className="clearfix"></div>
        </div>
        <div className="x_content">
          <div className="row">
            <div className="col-md-4 col-sm-3">
              <div className="form-group">
                <label className="label_text">Customer Name</label>
                <div className="casedetailTxt clearfix" title="">
                  <span className="hiddenText">
                    {caseDetails.customer_name} {caseDetails.last_name}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-sm-3 pad-R5">
              <div className="form-group">
                <label className="label_text">Phone Number</label>
                <div className="casedetailTxt clearfix" title="">
                  <span className="hiddenText">
                    {caseDetails.mobile !== ""
                      ? `+91-${caseDetails.mobile}`
                      : "--"}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-3">
              <div className="form-group">
                <label className="label_text">Buyer Type</label>
                <div className="casedetailTxt clearfix" title="">
                  <span className="hiddenText">
                    {caseDetails.buyer_type !== ""
                      ? caseDetails.buyer_type
                      : "--"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetails;
